/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Stack,
    Paper,
    Typography,
    Divider,
    Grid,
    Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import SaveIcon from '@mui/icons-material/Save';

import Layout from "../../../components/layout/Layout";
import Switch from "../../../components/form/Switch";
import InputText from "../../../components/form/InputText";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import AutoComplete from "../../../components/form/AutoComplete";
import FormatMoney from '../../../components/form/FormatMoney';
import validator from "./validator"

import DatePickerUi from '../../../components/form/DatePickerUi';

import { postFuel} from "../../../store/masters/thunk/fuel/post"

const NewEdit = () => {
    const formikRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("fuel");
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

    const post = useSelector(state => state.masters.fuel.post);
    const fuel = useSelector((state) => state.masters.fuel);

    const transportFuelType = __(`transportFuelType`, { returnObjects: true });

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                isDefault: true,
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); navigate(`/masters/fuels/${get(post, "id")}`); }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    }, [post])


    const onSubmit = (values) => {

        const body = {
            ...values,
            fuelType: Number(get(values, "fuelType", "")), 
            startDate: get(values, "startDate", ""), 
            endDate: get(values, "endDate", ""), 
            price: Number(get(values, "priceFuel", ""))
        }
       dispatch(postFuel(body))
    }

    const currentDate = new Date();  
    const futureDate = new Date(currentDate);  
    futureDate.setDate(currentDate.getDate() + 7); 

    const initialValues = {
        priceFuel: "",
        fuelType: "",
        startDate: currentDate,
        endDate: futureDate,
    }

    return (
        <Layout
            propsToolbar={{
                title: __(`head.new.name`),
                srute: __(`head.new.code`)
            }}
        >
            <Formik innerRef={formikRef} initialValues={initialValues} 
            validationSchema={validator(__)} 
            onSubmit={onSubmit}>
                {formik => (
                    <form id="form-client" onSubmit={get(formik, "handleSubmit")}>
                        <Paper className='p-4'>
                            <Stack direction="row" spacing={2} justifyContent="flex-end">
                                <LoadingButton variant="contained" color="secondary" type="submit" startIcon={<SaveIcon/>} loading={get(post, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                <Button variant='outlined' color="secondary" onClick={() => navigate("/masters/fuels/")} disabled={get(post, "isLoading")} >{__(`action.cancel`)}</Button>
                            </Stack>
                        </Paper>
                        <Paper className='mt-4'>
                            <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                            </Stack>
                            <Divider />
                            <Box className='p-4' >
                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                     <Grid item xs={12} sm={6}>
                                            <AutoComplete
                                                name={"fuelType"}
                                                formik={formik}
                                                label={__(`form.fuelType.label`)}
                                                placeholder={__(`form.fuelType.placeholder`)}
                                                disabled={get(post, "isLoading", false)}
                                                options={transportFuelType}
                                                loading={get(fuel, "isLoading")}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} >
                                            <InputText
                                                formik={formik}
                                                name="priceFuel"
                                                label={__(`form.priceFuel.label`)}
                                                placeholder={__(`form.priceFuel.placeholder`)}
                                                disabled={get(post, "isLoading", false)}
                                                InputProps={{
                                                    inputComponent: FormatMoney,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <DatePickerUi
                                                formik={formik}
                                                name="startDate"
                                                label={__(`form.startDate.label`)}
                                                placeholder={__(`form.startDate.placeholder`)}
                                                disabled={get(post, "isLoading", false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <DatePickerUi
                                                formik={formik}
                                                name="endDate"
                                                label={__(`form.endDate.label`)}
                                                placeholder={__(`form.endDate.placeholder`)}
                                                disabled={get(post, "isLoading", false)}
                                            />
                                        </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    </form>
                )}
            </Formik>
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                __={__}
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit
